module.exports = __webpack_public_path__ + "img/rating-2.cbf82da2.svg";